var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_1833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6374 13.6019C20.7459 10.4944 20.7459 5.43813 17.6374 2.33065C14.5289 -0.776883 9.47112 -0.776883 6.3626 2.33065C3.25413 5.43813 3.25413 10.4944 6.3626 13.6019C7.67838 14.9172 9.34343 15.6756 11.062 15.8775V18.5457H9.18616C8.66815 18.5457 8.24824 18.9656 8.24824 19.4834C8.24824 20.0012 8.66815 20.421 9.18616 20.421H11.062V23.0623C11.0621 23.5802 11.482 24 12 24C12.518 24 12.9379 23.5802 12.9379 23.0623V20.421H14.8138C15.3319 20.421 15.7518 20.0012 15.7518 19.4834C15.7518 18.9656 15.3319 18.5457 14.8138 18.5457H12.9379V15.8775C14.6566 15.6756 16.3216 14.9172 17.6374 13.6019ZM7.68907 12.2758C5.31199 9.89951 5.31199 6.03298 7.68907 3.65665C10.0661 1.28041 13.9338 1.28027 16.311 3.65665C18.6881 6.03298 18.6881 9.89951 16.311 12.2758C13.9339 14.6521 10.0661 14.6521 7.68907 12.2758Z",
    fill: "#17181B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_1833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleIcon);
export default __webpack_public_path__ + "static/media/female_icon.cc8181b6d4c1b5e57fb4563eaac236b0.svg";
export { ForwardRef as ReactComponent };